module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-6-1.abfba2c9.png";